import type { Recipe } from '../../types'
import { image } from '../helpers'

export const pizza: Recipe = {
  slug: 'pizza',
  title: 'Pâte à pizza classique',
  category: 'salé',
  description:
    'Calculateur de pâte à pizza selon une méthode classique, avec choix des pâtons, hydratation, farine, température et levure.',
  image: image('pizza'),
  tags: ['pizza', 'pâte', 'calculateur'],
  meta: [],
  sections: [],
  steps: [],
  special: 'pizza',
}
